<template>
  <section
    :class="{'contact-shared-form--fullHeight': fullHeight}"
    class="contact-shared-form"
  >
    <form-builder
      h2
      v-if="list"
      :list="list.forms"
      :is-horizontal="isHorizontal"
      :errors="error"
      @updateInputs="updatedInputs"
      @updateDateInputs="updatedDateInputs"
      @updateSelecterInputs="updatedSelecter"
      @updateRadioButton="updatedRadioButton"
    />
  </section>
</template>

<script>
import FormBuilder from '../shared/inputs/FormBuilder';

export default {
  components: {
    FormBuilder,
  },
  props: {
    error: {
      type: Object,
      default: null,
    },
    list: {
      type: Object,
      required: true,
      default: null,
    },
    isHorizontal: {
      type: Boolean,
      required: true,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // list: listCompany
    };
  },
  methods: {
    updatedInputs(val) {
      return this.$emit('updateInputs', val);
    },
    updatedDateInputs(val) {
      return this.$emit('updateDateInputs', val);
    },
    updatedSelecter(val) {
      return this.$emit('updateSelecterInputs', val);
    },
    updatedRadioButton(val) {
      return this.$emit('updateRadioButton', val);
    },
  },
};
</script>

<style lang="scss" scoped>

.contact-shared-form {
  background-color: $c-alabaster;
  display: flex;
  margin-bottom: 20px;

  &--fullHeight {
    flex: 1;
  }

  .form-builder {
    width: 100%;
  }

  ::v-deep h2 {
    white-space: initial;

    @include teq-breakpoint($medium) {
      white-space: nowrap;
    }
  }
}

</style>
